import React, { useContext, useEffect } from "react";
import { navigate } from 'gatsby'
import ButtonClose from "../../atoms/button-close/button-close";
import Button from "../../atoms/button/button";

import "./modal-end-game.scss";

import timesupimage from '../../../assets/images/modal-end-game/end-game-timesup.png';
import winimage from '../../../assets/images/modal-end-game/end-game-win.png';
import MessageWinPoints from "../../atoms/message-win-points/message-win-points";
import { Context } from "../../../context/app-context";
import   { pushEventData } from "../../../utils/pushEventDataLayer";
import { gameId } from '../../../constants/activity-constants'
import GameServices from '../../../services/game-service'
import userSessionStorage from "../../../utils/userSessionStorage";
const ModalEndGame = ({ points, win }) => {
    const { dispatch } = useContext(Context);
    const goTop = e => {
        e.preventDefault();
        navigate('/#top-jugadoras')
        dispatch({ type: 'clear-modal' });
    }
    const action_title = "Haz click aqui para volver a jugar";
    const action_label = "Volver a jugar";
    const ilustration = win ? winimage : timesupimage;
    const ilustration_alt = win ? "Muchacha dandote un ok por ganar sigue asi" : "muchacha riendo, aun lo puedes hacer mejor";
    const title = win ? "¿Tienes súper poderes?" : "¡Se te acabó el tiempo!";
    const description = win ? <>¿Quieres ver si estás entre los mejores puntajes? {' '}
        <a className="f-modal-end-game__link" onClick={goTop}>Haz clic aquí</a>
    </> : <>¡Vuelve a jugar y mejor suerte<br /> para la próxima!</>;
    const onAccept = () => {
        pushEventData({
            event: 'Pop-ups ',
            action: 'click',
            win,
            label: action_label,
        });
        window.location.reload()
    };
    const onclose = () => {
        navigate('/')
        dispatch({ type: 'clear-modal' })
    }

    const sendPoints = points => {


        let session = new userSessionStorage()
        let tokenParticipationSession = sessionStorage.getItem('tokenParticipation')
        if (!tokenParticipationSession) {
            return;
        }
        let payload = {
            point: points,
            tokenGame: tokenParticipationSession,
            gameId: gameId,
        }

        let tokenId = session.getToken()?.idToken

        let config = {
            headers: {
                Authorization: tokenId,
            },
        }

        GameServices.postGameParticipationSave(payload, config).then(res => {
            if (res.status === 200) {
                sessionStorage.removeItem('tokenParticipation')
            }
        })
    }

    const handleDataLayer = () => { 
        pushEventData({
            event: 'Pop-ups ',
            action: 'view',
            label: title,
            win
        }); 
    }

    useEffect(() => {
        if (points || points === 0) sendPoints(points)
        handleDataLayer()
    }, [])
    const titleContainer =
        <h1 className="f-modal-end-game__title">
            {title}
            {win && <p className="f-modal-end-game__description">Parece que sí porque completaste la frase</p>}
        </h1>;
    return <div className={"f-modal-end-game " + (win && "--win")}>
        <ButtonClose className="f-modal-end-game__close " onClick={onclose} title="cerrar modal y regresar al home" />


        <div className="f-modal-end-game__container ">
            <aside className={'f-modal-end-game__aside-image ' + (win && "--win")}>
                <figure className='f-modal-end-game__figure'>
                    <img className={'f-modal-end-game__image '} src={ilustration} alt={ilustration_alt} />
                </figure>
            </aside>
            <aside className='f-modal-end-game__aside-info'>
                {titleContainer}
                <MessageWinPoints icon="star" text1="Lograste " text2={points + " puntos"} />
                <p className="f-modal-end-game__description">{description}</p>
                <Button onClick={onAccept} title={action_title}>{action_label}</Button>
            </aside>
        </div>
    </div>;
}

export default ModalEndGame;